import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";
import Footer from "e4acomponents/Footer";

import MDBox from "components/MDBox";

import ChangeLogsTable from "../component/change-logs-table"

export default function PartCategoryChanges() {
    return (
        <DashboardLayout>
            <DashboardNavbar />

            <MDBox pt={6} pb={3}>
                <ChangeLogsTable documentType="partcategories" />
            </MDBox>
            <Footer />
        </DashboardLayout>
    )
}